import styled from "styled-components"

export const LayoutContainer = styled.div`
    padding: 0 20px;
    position: relative;
`;